module.exports = "https://static.energy5.com/_next/static/images/smartEnergy-07813afad47810fb5d8b95081b82fc25.png";